import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  FaCheckCircle,
  FaInfoCircle,
  FaExclamationTriangle,
  FaTimesCircle,
  FaSpinner,
  FaTimes,
} from 'react-icons/fa';
import {
  subscribeStatusMessages,
  dismissStatusMessage,
} from '../utils/statusMessageBus';
import './OnScreenStatusBar.css';

const ICONS = {
  success: FaCheckCircle,
  info: FaInfoCircle,
  warning: FaExclamationTriangle,
  error: FaTimesCircle,
  loading: FaSpinner,
};

/**
 * Full-width in-layout status messages (replaces corner toast pops for app feedback).
 */
export default function OnScreenStatusBar() {
  const { t } = useTranslation();
  const [items, setItems] = useState([]);

  useEffect(() => subscribeStatusMessages(setItems), []);

  if (!items.length) return null;

  return (
    <div
      className="onscreen-status"
      role="region"
      aria-label={t('common.statusMessages', 'Status messages')}
      aria-live="polite"
    >
      <div className="onscreen-status__inner">
        {items.map((item) => {
          const Icon = ICONS[item.type] || FaInfoCircle;
          return (
            <div
              key={item.id}
              className={`onscreen-status__item onscreen-status__item--${item.type}`}
              role={item.type === 'error' ? 'alert' : 'status'}
            >
              <Icon
                className={`onscreen-status__icon${item.type === 'loading' ? ' onscreen-status__icon--spin' : ''}`}
                size={18}
                aria-hidden
              />
              <p className="onscreen-status__text">{item.message}</p>
              <button
                type="button"
                className="onscreen-status__close"
                aria-label={t('common.dismiss', 'Dismiss')}
                onClick={() => dismissStatusMessage(item.id)}
              >
                <FaTimes size={14} aria-hidden />
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
